import React, { PureComponent } from 'react';

import Modal from '../../../../../components/Modal';
import { Form, FormGroup, SubmitButton } from '../../../../../components/Forms/Forms';
import { Input, Textarea, RichText } from '../../../../../components/Forms/fields/index';
import Auth from "../../../../../libs/Auth";

class DocumentationView extends PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      editMode: false,
    }
  }
  render() {
    const {
      formState,
      commentFormState,
      documentation,
      onFormUpdate,
      onCommentFormUpdate,
      submitForm,
      submitCommentForm,
      deleteComment,
      onClose,
      type,
    } = this.props;

    return (
      <Modal className="modal-container" active onClose={() => onClose()}>
        <h4>{type}</h4>
        {documentation ? (
          <div className="documentation-container">
            {Auth.isType(['admin', 'manager']) && (
              <div className="actions">
                <button onClick={()=>{
                          this.setState({
                            editMode: !this.state.editMode,
                          });
                        }}
                >{this.state.editMode ? (<i className="fi-x"></i>) : (<i className="fi-pencil"></i>)}</button>
              </div>
            )}
            <div className="documentation">
              {this.state.editMode ? (
                <Form state={formState} onSubmit={submitForm} onChange={onFormUpdate}>
                  <FormGroup name="text">
                    <RichText name="text" />
                  </FormGroup>
                  <button role="submit" className="button">Save</button>
                </Form>
              ) : (
                <div className="documentation-content" dangerouslySetInnerHTML={{__html: documentation.text}}>
                </div>
              )}

            </div>
            <div className="comments-container">
              <div className="comments">
                {documentation.comments.map((comment)=>(
                  <div className="comment">
                    <div className="comment-header">
                      <span className="username">{comment.username}</span>
                      <span className="date">{(new Date(comment.created).toLocaleString())}</span>
                      {Auth.isType(['admin', 'manager']) && (
                        <button
                          className="remove-button"
                          onClick={()=> {
                            deleteComment(comment._id);
                          }}
                        >remove</button>
                      )}
                    </div>
                    <div className="comment-body">
                      {comment.comment}
                    </div>
                  </div>
                ))}

              </div>
              <Form state={commentFormState} onSubmit={submitCommentForm} onChange={onCommentFormUpdate}>
                <FormGroup name="text">
                  <Textarea name="comment" />
                </FormGroup>
                <button role="submit" className="button">Add Comment</button>
              </Form>
            </div>
          </div>
        ) : (
          <div>loading...</div>
        )}

      </Modal>
    )
  }
}

export default DocumentationView;



// WEBPACK FOOTER //
// ./src/app/modules/WorkArea/Trades/TradeDetails/Documentation/Documentation.view.js